export {
    renderWithCreateRange,
}

function renderWithCreateRange(container, html) {
    const range = document.createRange();
    range.setStart(container, 0);
    container.appendChild(
        range.createContextualFragment(html)
    );
}
